export default {
  customer: {
    label: "Client",
    telephone1: "Téléphone 1",
    telephone2: "Téléphone 2",
    active: "Client actif",
    solded: "A soldé",
    totalToPay: "Total à payer",
    totalPaid: "Total payé",
    add: {
      title: "Ajouter un client",
      confirm: "Ajouter"
    },
    fields: {
      nom: "Nom",
      prenom: "Prénoms",
      telephone1: "Téléphone 1",
      telephone2: "Téléphone 2"
    },
    update: {
      title: "Modifier un client",
      confirm: "Modifier",
      cancel: "Annuler"
    },
    nameOnly: "Nom",
    firstname: "Prénoms",
    filter: {
      title: "Filtrer la liste des clients",
      isActive: "Client actif ?",
      isSold: "A soldé ?",
      village: "Village / Quartier",
      selectVillage: "Sélectionner un village",
      buttons: {
        filter: "Filtrer",
        clear: "Vider les filtres",
        cancel: "Annuler"
      }
    },
    delete: {
      title: "Supprimer",
      body: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
      confirm: "Supprimer"
    },
    eligibleMeters: "Compteurs éligibles",
    addressedMeters: "Compteurs adressés",
    name: "Nom & prénom",
    phone1: "Téléphone 1",
    phone2: "Téléphone 2",
    placeMeter: "Nb d'emplacement  compteur",
    isSold: "A soldé ?",
    isActive: "Est actif ?",
    actions: "Actions",

    double: {
      table: {
        name: "Nom & prénom",
        firstname: "Prénom",
        phone1: "Téléphone 1",
        phone2: "Téléphone 2",
        isActive: "Actif ?",
        isSold: "Soldé ?",
        isValidated: "Validé ?",
        placeMeter: "Nb d'emplacement compteur",
        actions: "Actions",
        meters: "Compteurs",
        uuidONA: "UUID ONA",
        eligible: "Éligible ?",
        latitude: "Latitude",
        longitude: "Longitude",
        twoWires: "2 Fils",
        fourWires: "4 Fils",
        companyWorks: "Nom Entreprise Tvx",
        surveyor: "Enquêteur",
        duplicateCount: "Nb d'occurrences",
        isSolded: "A soldé ?",
      },
      buttons: {
        refresh: "Actualiser",
        combine: "Fusionner",
        modify: "Modifier le client",
        details: "Voir le détail du client",
        delete: "Supprimer le client",
        validate: "Valider le client",
        unvalidate: "Dévalider le client",
        meters: "Compteurs",
        map: "Carte",
        confirmUpdate: "Modifier",
        cancel: "Annuler",
        settings: "Paramètres",
        viewDuplicates: "Voir les doublons",
        view: "Voir"
      },
      modals: {
        deleteTitle: "Supprimer",
        deleteBody: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
        deleteConfirm: "Supprimer",
        updateTitle: "Modifier un client",
        updateConfirm: "Modifier",
        updateCancel: "Annuler",
        settingsTitle: "Paramètres de doublons",
      },
      settings: {
        settingsTitle: "Paramètres de doublons",
        compareNameFirstname: "Comparer le nom et le prénom",
        comparePhone: "Comparer le numéro de téléphone",
        compareInvestigator: "Comparer l’enquêteur",
        compareGPS: "Comparer la position GPS",
        gpsPrecision: "Précision GPS :"
      }
    }
  },
  placeMeters: {
    popupTitle: "Ajout d'un emplacement compteur",
    steps: {
      step1: "Zone de résidence",
      step2: "Position GPS",
      step3: "Nombre de compteur",
      step4: "Informations client",
      step5: "Enquêteur et références"
    },
    labels: {
      villageQuartier: "Village/Quartier",
      latitude: "Latitude",
      longitude: "Longitude",
      compteur2Fils: "Compteurs 2 fils",
      compteur4Fils: "Compteurs 4 fils",
      systemeElectriqueDispo: "Système électrique disponible ?",
      equipementLourdDispo: "Équipement lourd disponible ?",
      typeAbonne: "Type d'abonné",
      raisonSociale: "Raison sociale",
      nom: "Nom",
      prenom: "Prénom",
      telephone: "Téléphone",
      typeAgr: "Type AGR",
      typeInfra: "Type d'infrastructure",
      typeInfraDetail: "Détails sur l'infrastructure",
      nomEnqueteur: "Nom enquêteur",
      commentaireEnqueteur: "Commentaire enquêteur",
      reference: "Référence",
      dateEnquete: "Date enquête"
    },
    placeholders: {
      villageQuartier: "Choisissez un village/quartier",
      typeAbonne: "Choisissez le type de client",
      typeAgr: "Choisissez un type",
      typeInfra: "Choisissez un type"
    },
    switches: {
      yes: "Oui",
      no: "Non"
    },
    errors: {
      required: "Ce champ est obligatoire",
      invalidNumber: "Valeur numérique invalide"
    },
    buttons: {
      add: "Ajouter",
      cancel: "Annuler",
      next: "Suivant",
      previous: "Précédent"
    }
  },
  meter: {
    list: "Compteurs",
    addTitle: "Ajouter un compteur",
    editTitle: "Modifier le compteur",
    meterNumber: "Compteur N°{num}",
    meterType: "Type de compteur",
    selectType: "Sélectionner le type de compteur",
    length2x16: "2 x 16 mm²",
    length4x16: "4 x 16 mm²",
    subscriptionDate: "Date abonnement",
    connectionDate: "Date raccordement",
    activationDate: "Date mise en service",
    subscriptionNumber: "Numéro police abonnement",
    breakerType: "Type disjoncteur",
    selectBreakerType: "Sélectionner le type disjoncteur",
    breakerSetting: "Réglage disjoncteur",
    selectBreakerSetting: "Sélectionner le réglage disjoncteur",
    delete: {
      title: "Supprimer",
      body: "Souhaitez-vous vraiment supprimer ce compteur ?",
      confirm: "Supprimer",
      action: "Supprimer le compteur"
    },
    none: "Aucun compteur à afficher"
  },
  map: {
    title: "Carte"
  }
};
